import { Checkbox, Snackbar } from "@material-ui/core";
import { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import getCurrentUserId from "../../../../reduxSaga/sagas/requests/currentUserId";
import { useNavigate } from "react-router-dom";
import UOMService from "../../../../services/Production/UOMService";
import UtilsFormule from "../../../../utils/UtilsFormule";

const NewUnitOfMesure = () => {
    const navigate = useNavigate();
    const [openErrorAlert, setOpenErrorAlert] = useState(false);
    const [errorAlertText, setErrorAlertText] = useState();
    const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
    const [successAlertText, setSuccessAlertText] = useState();
    const [code, setCode] = useState("");
    const [valeur, setValeur] = useState("");

    const [name, setName] = useState("");
    const [typeUnite, setTypeUnite] = useState(0);
    const [defaultUnit, setDefaultUnit] = useState(0);
    const [listSkus, setListSkus] = useState([]);
    useEffect(() => {
        UOMService.getAllCodeUOM(getCurrentUserId(), 0).then((result) => {
          setListSkus(result.data["success"]);
        });
      }, []);

    const handleEroorClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenErrorAlert(false);
    };

    const handleSuccessClose = (event, reason) => {
        if (reason === "clickaway") {
            return;
        }
        setOpenSuccessAlert(false);
    };



    const onChangeCodeHandler = (event) => {
        setCode(event.target.value);
    };
    const onChangeValeurHandler = (event) => {
        setValeur(event.target.value);
    };
    const onChangeNameHandler = (event) => {
        setName(event.target.value);
    };
    const onValidUOMHandler = () => {
        let model = {
            name: name,
            code: code,
            defaultUnit:defaultUnit,
            typeUnite:typeUnite,
            valeur:valeur,
            idUser: getCurrentUserId(),
        };
        UOMService.addUnitOfMesure(model)
            .then((response) => {
                if (response.data["success"]) {
                    setOpenSuccessAlert(true);
                    setSuccessAlertText("Enregistrement avec succées");
                    setTimeout(() => {
                        navigate(`/uom`);
                    }, 2000);
                } else {
                    setOpenErrorAlert(true);
                    setErrorAlertText("Erreur :erreur serveur ");
                }
            })
            .catch((e) => {
                console.log("error", e);
            });


    };
    const onValueChange = (event) => {
        if (event.target.value === "1") {
            setTypeUnite(1);
        } else if (event.target.value === "2") {
            setTypeUnite(2);
        } else if (event.target.value === "3") {
            setTypeUnite(3);
        }
    };
    const onchooseDefaultHandler = () => {
        if (defaultUnit === 0) {
            setDefaultUnit(1);
        } else if (defaultUnit === 1) {
            setDefaultUnit(0);
        }

    };

    const blocDefaultValue = () => {
        if (defaultUnit === 0) {
            return (
                <div className="row">
                    <div className="col-md-2">
                        <label htmlFor="inputName">Valeur</label>
                    </div>
                    <div className="col-md-10">
                        <div className="form-group">
                            <input
                                placeholder="saisir la valeur par rapport au défaut"
                                onChange={onChangeValeurHandler}
                                type="text"
                                id="inputName"
                                className="form-control"
                            />
                        </div>
                    </div>
                </div>

            );
        } else if (defaultUnit === 1) {
            return <></>;
        }
    };
    let skuPossible = UtilsFormule.generateSKU(name, listSkus);

    return (
        <div className="content-wrapper" style={{ marginTop: "0" }}>
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-6"></div>
                        <div className="col-md-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">Home</li>
                                <li class="breadcrumb-item active">
                                    Ajouter Unité de mesure
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content ">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-dark">
                                <div className="card-header">
                                    <h5 className="card-title">
                                        {" "}
                                        Ajouter Unité de mesure
                                    </h5>
                                </div>
                                <div className="card-body">
                                    <div className="row">
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="inputName">Code {skuPossible}</label>
                                                <input
                                                    placeholder="Ajouter réference "
                                                    onChange={onChangeCodeHandler}
                                                    type="text"
                                                    id="inputName"
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                        <div className="col-sm-6">
                                            <div className="form-group">
                                                <label htmlFor="inputName">Libellé</label>
                                                <input
                                                    placeholder="Ajouter libellé "
                                                    onChange={onChangeNameHandler}
                                                    type="text"
                                                    id="inputName"
                                                    className="form-control"
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div class="form-group  clearfix">
                                            <div class="icheck-asbestos d-inline">
                                                <input
                                                    id="poid"
                                                    type="radio"
                                                    name="poid"
                                                    value="1"
                                                    checked={typeUnite === 1}
                                                    onChange={onValueChange}
                                                />
                                                <label for="poid">Poid </label>{" "}
                                            </div>

                                            <div class="icheck-asbestos d-inline">
                                                <input
                                                    id="volume"
                                                    type="radio"
                                                    name="volume"
                                                    value="2"
                                                    checked={typeUnite === 2}
                                                    onChange={onValueChange}
                                                />

                                                <label for="volume"> Volume</label>
                                            </div>
                                            <div class="icheck-asbestos d-inline">
                                                <input
                                                    id="unit"
                                                    type="radio"
                                                    name="unit"
                                                    value="3"
                                                    checked={typeUnite === 3}
                                                    onChange={onValueChange}
                                                />

                                                <label for="unit"> Unité</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-sm-4">
                                            <div class="form-group">
                                                <Checkbox
                                                    label="Par défaut"
                                                    value={defaultUnit}
                                                    onChange={onchooseDefaultHandler}
                                                    style={{ color: "black" }}
                                                />

                                                <label class="form-check-label" for="inlineRadio1">
                                                    Par défaut
                                                </label>
                                            </div>
                                        </div>
                                        <div className="col-sm-8"> {blocDefaultValue()}</div>

                                    </div>

                                </div>

                                <div class="card-footer" style={{ marginTop: "1%" }}>
                                    <button
                                        class="btn btn-dark float-right"
                                        style={{ marginTop: "1%" }}
                                        onClick={onValidUOMHandler}
                                    >
                                        Confirmer
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Snackbar
                open={openErrorAlert}
                autoHideDuration={2000}
                onClose={handleEroorClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleEroorClose} severity="error">
                    {errorAlertText}
                </Alert>
            </Snackbar>

            <Snackbar
                open={openSuccessAlert}
                autoHideDuration={2000}
                onClose={handleSuccessClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
            >
                <Alert variant="filled" onClose={handleSuccessClose} severity="success">
                    {successAlertText}
                </Alert>
            </Snackbar>
        </div>
    );
};
export default NewUnitOfMesure;
